<template>
  <div class="row">
    <div class="col-12">
      <div
          class="col-12"
          style="padding: 0; margin: 0 -6px"
          v-if="userHasTeams || userIsAdmin"
      >
        <ul class="nav nav-pills nav-fill" role="tablist">
          <li
              class="nav-item nav-border-override"
              role="presentation"
              style="margin-left: -15px"
          >
            <a
                class="nav-link cursor-pointer"
                :class="{ active: tab === 'yours_task' }"
                id="yours_task-tab"
                aria-controls="yours_task"
                aria-selected="true"
                @click="showTab('yours_task')"
            >
              Yours
            </a>
          </li>
          <li
              class="nav-item nav-border-override"
              role="presentation"
              style="margin-right: -27px"
              v-if="userHasTeams"
          >
            <a
                class="nav-link cursor-pointer"
                :class="{ active: tab === 'team_task' }"
                id="team_task-tab"
                aria-controls="team_task"
                aria-selected="true"
                @click="showTab('team_task')"
            >
              Team
            </a>
          </li>
          <li
              class="nav-item nav-border-override"
              role="presentation"
              style="margin-right: -27px"
              v-if="userIsAdmin"
          >
            <a
                class="nav-link cursor-pointer"
                :class="{ active: tab === 'company_task' }"
                id="company_task-tab"
                aria-controls="company_task"
                aria-selected="true"
                @click="showTab('company_task')"
            >
              Company
            </a>
          </li>
        </ul>
      </div>
      <div class="pt-4">
        <div class="tab-content" id="pills-tabContent">
          <div
              class="tab-pane fade show active"
              v-if="tab === 'yours_task'"
              id="yours_task"
              role="tabpanel"
              aria-labelledby="yours_task-tab"
          >
            <your-tasks
                :yourTodoTasks="yourTodoTasks"
                :yourHourlyTasks="yourHourlyTasks"
                :yourGoals="yourGoals"
                @storeTasksLocally="storeTasksLocally"
            />
          </div>

          <div
              class="tab-pane fade show active"
              v-if="tab === 'team_task'"
              id="team_task"
              role="tabpanel"
              aria-labelledby="team_task-tab"
          >
            <team-tasks
                :teamTasks="teamTasks"
                :teamGoals="teamGoals"
                @storeTasksLocally="storeTasksLocally"
            />
          </div>

          <div
              class="tab-pane fade show active"
              v-if="tab === 'company_task'"
              id="company_task"
              role="tabpanel"
              aria-labelledby="company_task-tab"
          >
            <company-tasks
                :companyTasks="companyTasks"
                :companyGoals="companyGoals"
                @storeTasksLocally="storeTasksLocally"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tab: this.getPersistedTaskTab(),
      yourTodoTasks: null,
      yourHourlyTasks: null,
      yourGoals: null,
      teamTasks: null,
      teamGoals: null,
      companyTasks: null,
      companyGoals: null,
    };
  },

  computed: {
    currentUser () {
      return this.$store.state.currentUser;
    },

    userIsAdmin () {
      return this.$store.state.isAdmin;
    },

    userHasTeams () {
      return this.teams.length > 0;
    },

    teams () {
      return this.$store.state.userTeams;
    },
  },

  methods: {
    getPersistedTaskTab () {
      return localStorage.getItem('wfhTT') ?? 'yours_task';
    },

    showTab (tab) {
      localStorage.setItem('wfhTT', tab);
      this.tab = tab;
    },

    storeTasksLocally (data) {
      const { key, tasks } = data;

      this[key] = tasks;
    },
  },
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
</style>
